import React, { useCallback } from 'react';
import { Box, Button } from '@wix/design-system';
import { AssistantWidgetComponent } from '../types';
import { MessageDisplay } from './components/MessageDisplay';

export const DOWNLOAD_APP_WIDGET = 'DOWNLOAD_APP_WIDGET';

export const DownloadAppWidget: AssistantWidgetComponent = (props) => {
  const {
    data: {
      data: { iosDownloadAppUrl },
    },
  } = props;

  const onClick = useCallback(() => {
    window.open(iosDownloadAppUrl, '_blank', 'noopener,noreferrer');
  }, [iosDownloadAppUrl]);

  return (
    <MessageDisplay message="Want to have your own personal assistant? download the Nownia app!">
      <Box marginTop={2}>
        <Button fullWidth={false} size="small" onClick={onClick}>
          Download app
        </Button>
      </Box>
    </MessageDisplay>
  );
};
